import { ENV, SENTRY_DSN, SENTRY_ENABLED } from "commons/config";
import "./polyfills";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import ErrorBoundary from "./containers/errorBoundary/ErrorBoundary";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-phone-input-2/lib/style.css";
import reportWebVitals from "./reportWebVitals";

// ─── Sentry init — deferred until after initial render ──────
// Moved to end of file
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/serviceworker.js")
      .then((reg) => console.log("SW registered:", reg))
      .catch((err) => console.log("SW registration failed:", err));
  });
}

const Index = () => {
  return <App />;
};

ReactDOM.render(
  <BrowserRouter>
    <React.StrictMode>
      <ErrorBoundary>
        <Index />
      </ErrorBoundary>
    </React.StrictMode>
  </BrowserRouter>,
  document.getElementById("root"),
);

if (SENTRY_ENABLED === "true") {
  // Gate the entire Sentry initialisation behind the first real user interaction.
  // FALLBACK:
  //   setTimeout(15000) covers passive users who open the page but don't interact
  //   (e.g. reading content). Sentry still inits for them — just 15s later.

  let sentryInited = false;

  const initSentry = () => {
    if (sentryInited) return;
    sentryInited = true;

    import("@sentry/react").then((Sentry) => {
      Sentry.init({
        dsn: SENTRY_DSN,
        sendDefaultPii: true,
        integrations: [
          Sentry.browserTracingIntegration(),
        ],
        tracesSampleRate: 0.1,
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
        enableLogs: true,
        environment: ENV,
      });

      // Add Replay immediately on init — by this point the user has already
      // interacted, so rrweb starts recording from an interactive DOM state,
      // not from a mid-load snapshot.
      Sentry.addIntegration(
        Sentry.replayIntegration({
          maskAllInputs: true,
        })
      );
    });
  };

  // Trigger on first real interaction
  ["click", "keydown", "touchstart", "scroll"].forEach((event) => {
    document.addEventListener(event, initSentry, {
      once: true,
      capture: true,
      passive: true,
    });
  });

  // Fallback: passive users who never interact (reading, idle tab)
  setTimeout(initSentry, 15000);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
